export default __webpack_public_path__ + "static/media/future.52a40219.svg";